import { useSession } from "@src/appV2/Auth/api/useSession";
import { WORKPLACE_TYPES } from "@src/appV2/constants/workplaceTypes";
import { environmentConfig } from "@src/appV2/environment";
import { useToast } from "@src/appV2/lib";

import { useGetPlacementsAccessLevel } from "../useGetPlacementsAccessLevel";

export function useGetHiringUrl() {
  const { profile } = useSession();
  const { showSuccessToast } = useToast();
  const { isEnabled: isPlacementsEnabled } = useGetPlacementsAccessLevel();

  const isChildcareType = profile.type === WORKPLACE_TYPES.CHILD_CARE_CENTER;

  const getPlacementHiringUrl = (placementId: string) =>
    `${environmentConfig.REACT_APP_CLIPBOARD_HIRING_BASE_URL}/workplaces/${profile.userId}/placements/${placementId}/apply`;

  const getWorkplaceHiringUrl = () =>
    `${environmentConfig.REACT_APP_CLIPBOARD_HIRING_BASE_URL}/workplaces/${profile.userId}/apply`;

  const copyWorkplaceHiringUrl = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    navigator.clipboard.writeText(getWorkplaceHiringUrl());
    showSuccessToast("Workplace hiring URL copied to clipboard");
  };

  return {
    isEnabled: isPlacementsEnabled && isChildcareType,
    getPlacementHiringUrl,
    copyWorkplaceHiringUrl,
  };
}
